import React, { useState } from "react";
import { formatDateToWords } from "../../../utilities/dateUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsis,
  faMagnifyingGlass,
  faThumbsDown,
  faThumbsUp,
} from "@fortawesome/free-solid-svg-icons";
import AdministrativeTransactionRequest from "../../../interfaces/adminRequests/AdministrativeTransactionRequest";
import { useNavigate } from "react-router-dom";
import { toTitleCase } from "../../../utilities/stringUtils";
import { Table } from "react-bootstrap";
import rejectbtnicon from '../../../assets/images/rejectbtnicon.svg';
import approvebtnicon from '../../../assets/images/approvebtnicon.svg';

interface AdminRequestsTableProps {
  transactions: AdministrativeTransactionRequest[];
  organizationName: string;
  approveTask: (id: number) => void;
  rejectTask: (id: number) => void;
}

const AdminRequestsTable: React.FC<AdminRequestsTableProps> = ({
  transactions,
  organizationName,
  approveTask,
  rejectTask
}) => {
  const navigate = useNavigate();
  const [toggleMenu, setToggleMenu] = useState<number>();

  const toggleMenuTrigger = (id: number) => {
    if (id === toggleMenu) {
      setToggleMenu(undefined);
    } else {
      setToggleMenu(id);
    }
  };

  return (
    <>
      <div className='common_content_inner mby_t_24'>
        <Table responsive className="common_table">
          {/* Table Header */}
          <thead>
            <tr>
              <th>Requested By</th>
              <th>Approver</th>
              <th>Type</th>
              <th>Task</th>
              <th>Requested</th>
              <th>Response</th>
              <th>Status</th>
              <th className="action_th">Action</th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>
            {transactions.map((tx, index) => (
              <tr
                key={tx.id}
                className={` ${index % 2 === 1 ? "" : ""} `}
              >
                <td>
                  {tx.requesterName}
                </td>
                <td>
                  {tx.approverName ? tx.approverName : "--"}
                </td>
                <td>
                  {toTitleCase(tx.transactionType)}
                </td>
                <td
                  className={`px-6 py-4 whitespace-nowrap text-sm flex items-center align-middle ${tx.taskId ? "text-blue-600 cursor-pointer" : "text-gray-900"
                    }`}
                  onClick={() => {
                    if (tx.taskId)
                      navigate(`/task/${organizationName}-${tx.taskId}`);
                  }}
                >
                  {tx.taskId ? organizationName + "-" + tx.taskId : "N/A"}
                </td>
                <td>
                  {formatDateToWords(new Date(tx.requestTime))}
                </td>
                <td>
                  {tx.completionTime
                    ? formatDateToWords(new Date(tx.completionTime))
                    : "--"}
                </td>
                <td>
                  <div
                    className={`p-1 ${((tx.status ?? "").toLowerCase()).includes("pending")
                        ? "bg-yellow-100 text-yellow-700"
                        : ((tx.status ?? "").toLowerCase()).includes("approved")
                          ? "bg-green-100 text-green-700"
                          : ((tx.status ?? "").toLowerCase()).includes("rejected")
                            ? "bg-red-100 text-red-700"
                            : "bg-blue-300 text-blue-700"
                      } text-xs rounded inline`}
                  >
                    {tx.status}
                  </div>
                </td>
                {/* <td>
                <FontAwesomeIcon
                  icon={faEllipsis}
                  className="cursor-pointer"
                  onClick={() => toggleMenuTrigger(tx.id)}
                />
              {toggleMenu === tx.id && (
                <div className="absolute bg-white select-none shadow-lg z-10 text-sm rounded right-0 top-10">
                  <div className="p-2 hover:bg-gray-100 cursor-pointer flex align-middle items-center gap-2 bg-blue-50 text-blue-700"
                  onClick={() => approveTask(tx.id)}>
                    <FontAwesomeIcon icon={faThumbsUp} />
                    <div>Approve</div>
                </div>
                  <div className="p-2 hover:bg-gray-100 cursor-pointer text-red-600 flex gap-2 align-middle items-center bg-red-50"
                  onClick={() => rejectTask(tx.id)}>
                  <FontAwesomeIcon icon={faThumbsDown} />
                  <div>Reject</div>
                  </div>
                </div>
              )}
              </td> */}
                <td>
                  <div className="action_btn">
                    <button onClick={() => rejectTask(tx.id)}><img src={rejectbtnicon} alt="rejectbtnicon" /></button>
                    <button onClick={() => approveTask(tx.id)}><img src={approvebtnicon} alt="approvebtnicon" /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {transactions.length === 0 && (
          <div className="absolute text-muted text-center -translate-y-1/2  translate-x-1/2 right-1/2 top-1/2 flex flex-col items-center align-middle justify-center">
            <FontAwesomeIcon className="text-8xl mb-5" icon={faMagnifyingGlass} />
            <div>No results found</div>
          </div>
        )}
      </div>
    </>
  );
};

export default AdminRequestsTable;
